import { InjectedConnector } from '@web3-react/injected-connector';

const NETWORK_ID_BSC = Number(process.env.REACT_APP_BSC_CHAIN_ID_DECIMAL);
const NETWORK_ID_KCC = Number(process.env.REACT_APP_KCC_CHAIN_ID_DECIMAL);

export const injected = new InjectedConnector({
  // supportedChainIds: [NETWORK_ID_BSC, NETWORK_ID_KCC],
});
